export default __webpack_public_path__ + "static/media/vision.6e52b746.png";